import store from '../store';
import Block from './Block'

export default class Partners extends Block {
  onEnterCompleted() {
    this.inView = false
    this.observer()
  }

  observer() {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting && !this.inView) {
          this.inView = true
          store.smoothScroll.update()
        }
      })
    })

    observer.observe(this.el)
  }
}
